import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUserInfoStore = defineStore('userInfo', () => {
  // State
  const status = ref('idle')
  const userInfo = ref({})
  const error = ref(null)
  const profileGroup = ref({})

  // Getters
  const getStatus = computed(() => status.value)
  const getUserInfo = computed(() => userInfo.value)
  const getError = computed(() => error.value)
  const loading = computed(() => ['fetching', 'updating', 'fetchingProfile'].includes(status.value))
  const isFetching = computed(() => status.value === 'fetching')
  const isUpdating = computed(() => status.value === 'updating')
  const isFetchingProfile = computed(() => status.value === 'fetchingProfile')

  const hasUserInfo = computed(() => {
    return Object.keys(userInfo.value).length > 0
  })

  const isSettleEnable = computed(() => {
    const { bank_amount, withdraw_rule, activity_withdraw_limit, activity_target_withdraw_limit } = userInfo.value || {}
    if (parseFloat(bank_amount || 0) >= 0 && activity_withdraw_limit !== undefined && activity_target_withdraw_limit !== undefined) {
      return withdraw_rule !== 'DEFAULT' && (activity_target_withdraw_limit < 0 ? activity_withdraw_limit === 0 : true)
    }
    return false
  })

  const isVerified = computed(() => userInfo.value?.verification_status === 1)

  // Actions
  function setStatus(data) {
    status.value = data
  }

  function setUserInfo(data) {
    userInfo.value = data
  }

  function setError(data) {
    error.value = data
  }

  function setProfileGroup(data) {
    profileGroup.value = data
  }

  return {
    // State
    status,
    userInfo,
    error,
    profileGroup,

    // Getters
    getStatus,
    getUserInfo,
    getError,
    loading,
    isFetching,
    isUpdating,
    hasUserInfo,
    isSettleEnable,
    isVerified,
    isFetchingProfile,
    
    // Actions
    setStatus,
    setUserInfo,
    setError,
    setProfileGroup,
  }
})
